window.CreatePostTopicPicker = new function()
{
    this.vars = {
      token: jQuery('meta[name="csrf-token"]').attr('content')
    };

    this.init = function() {
        jQuery('body').on('change', '.post-create-topic-picker select[name="topic_id"]', function(event) {
            var topic_id = jQuery(this).find('option:selected').val();
            CreatePostTopicPicker.populateSubtopics(topic_id);
        });
    };

    /**
     * Populate subtopics dropdown from selected topic
     *
     * @param int topic_id
     */
    this.populateSubtopics = function(topic_id) {
        jQuery('.post-create-topic-picker .topic-subtopic-id-select-container').empty();

        $.ajax({
            url: '/post-create-topic-picker/subtopic',
            type: 'POST',
            data: {
                topic_id: topic_id,
                _token: CreatePostTopicPicker.vars.token
            },
            showloader: true,
            success: function(response) { 
                jQuery('.topic-picker-remove').empty();
                jQuery('.post-create-topic-picker .topic-subtopic-id-select-container').html(response);
                jQuery('.post-create-topic-picker .topic-subtopic-id-select-container select').select2();
            }
        });
    };
}

jQuery(document).ready(function($) {
    CreatePostTopicPicker.init();
});
